import { render, staticRenderFns } from "./CommentsChapter.vue?vue&type=template&id=b35eccac&scoped=true"
import script from "./CommentsChapter.vue?vue&type=script&lang=js"
export * from "./CommentsChapter.vue?vue&type=script&lang=js"
import style0 from "./CommentsChapter.vue?vue&type=style&index=0&id=b35eccac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35eccac",
  null
  
)

export default component.exports